module.exports = __webpack_public_path__ + "static/media/give_schemes.9f5136ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/give_schemes.svg
// module id = 173
// module chunks = 0